export default __webpack_public_path__ + "static/media/card6.a8a487e1.svg";